import {css} from 'lit';
export const styles = css`:host([layout='xs']) {
  width: 30px;
  width: var(--avatar-size, 30px);
  height: 30px;
  height: var(--avatar-size, 30px);
  font-size: calc(30px * 0.4);
  font-size: calc(var(--avatar-size, 30px) * 0.4);
}

:host([layout='xs']) ef-icon {
  font-size: calc(30px * 0.64);
  font-size: calc(var(--avatar-size, 30px) * 0.64);
}

:host([layout='sm']) {
  width: 40px;
  width: var(--avatar-size, 40px);
  height: 40px;
  height: var(--avatar-size, 40px);
  font-size: calc(40px * 0.4);
  font-size: calc(var(--avatar-size, 40px) * 0.4);
}

:host([layout='sm']) ef-icon {
  font-size: calc(40px * 0.64);
  font-size: calc(var(--avatar-size, 40px) * 0.64);
}

:host([layout='md']) {
  width: 50px;
  width: var(--avatar-size, 50px);
  height: 50px;
  height: var(--avatar-size, 50px);
  font-size: calc(50px * 0.4);
  font-size: calc(var(--avatar-size, 50px) * 0.4);
}

:host([layout='md']) ef-icon {
  font-size: calc(50px * 0.64);
  font-size: calc(var(--avatar-size, 50px) * 0.64);
}

:host([layout='lg']) {
  width: 80px;
  width: var(--avatar-size, 80px);
  height: 80px;
  height: var(--avatar-size, 80px);
  font-size: calc(80px * 0.4);
  font-size: calc(var(--avatar-size, 80px) * 0.4);
}

:host([layout='lg']) ef-icon {
  font-size: calc(80px * 0.64);
  font-size: calc(var(--avatar-size, 80px) * 0.64);
}

:host([layout='xl']) {
  width: 120px;
  width: var(--avatar-size, 120px);
  height: 120px;
  height: var(--avatar-size, 120px);
  font-size: calc(120px * 0.4);
  font-size: calc(var(--avatar-size, 120px) * 0.4);
}

:host([layout='xl']) ef-icon {
  font-size: calc(120px * 0.64);
  font-size: calc(var(--avatar-size, 120px) * 0.64);
}

:host {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  border-radius: var(--avatar-border-radius, 4px);
  background-color: var(--gray-500);
}

img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border-radius: var(--avatar-border-radius, 4px);
  object-fit: cover;
}

.name {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border-radius: var(--avatar-border-radius, 4px);
  color: var(--gray-100);
  font-weight: 600;
  text-transform: uppercase;
}

.label {
  position: absolute;
  left: 50%;
  bottom: 4px;
  padding: 4px;
  background: var(--gray-300);
  border-radius: 4px;
  border: 2px solid #fff;
  font-size: 10px;
  font-size: var(--label-font-size, 10px);
  line-height: 1;
  transform: translate(-50%, 50%);
}

ef-icon {
  color: var(--gray-100);
}

:host([rounded]) {
  border-radius: 50%;
  border-radius: var(--avatar-border-radius, 50%);
}

:host([rounded]) .name {
  border-radius: 50%;
  border-radius: var(--avatar-border-radius, 50%);
}

:host([rounded]) img {
  border-radius: 50%;
  border-radius: var(--avatar-border-radius, 50%);
}

:host([rounded]) ef-icon {
  position: relative;
  top: -1px;
}
`;
export default styles;
